import { removeAllTagsFromMarkdown } from '../../utils/markdown';
const transformSaveBuildRequest = (buildName, currentVehicle, selectedAccessories, selectedProtections, selectedWarranty, paymentData, summary, selectedOffers, summaryApiResponse, isWarrantyRecommended, selectedWarrantyType, isOnlineCreditApplication) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const sanitizedCurrentVehicle = {};
    const exteriorColorPricing = (_b = (_a = paymentData === null || paymentData === void 0 ? void 0 : paymentData.data) === null || _a === void 0 ? void 0 : _a.exteriorColors) === null || _b === void 0 ? void 0 : _b.find(c => c.key === (currentVehicle === null || currentVehicle === void 0 ? void 0 : currentVehicle.exteriorColourKey));
    const interiorColorPricing = (_c = exteriorColorPricing === null || exteriorColorPricing === void 0 ? void 0 : exteriorColorPricing.interiorColours) === null || _c === void 0 ? void 0 : _c.find(c => c.key === (currentVehicle === null || currentVehicle === void 0 ? void 0 : currentVehicle.interiorColourKey));
    Object.keys(currentVehicle).forEach(key => {
        const value = currentVehicle[key];
        if (typeof value === 'undefined') {
            sanitizedCurrentVehicle[key] = '';
        }
        else
            sanitizedCurrentVehicle[key] = removeAllTagsFromMarkdown(value) || '';
    });
    // eslint-disable-next-line no-param-reassign
    currentVehicle = sanitizedCurrentVehicle;
    const transformedRequest = {
        Key: null,
        Name: removeAllTagsFromMarkdown(buildName),
        Model: {
            Id: (currentVehicle === null || currentVehicle === void 0 ? void 0 : currentVehicle.detIdentifier) || 0,
            Key: currentVehicle === null || currentVehicle === void 0 ? void 0 : currentVehicle.key,
            Name: currentVehicle === null || currentVehicle === void 0 ? void 0 : currentVehicle.name,
            Year: currentVehicle === null || currentVehicle === void 0 ? void 0 : currentVehicle.year,
            GtmName: currentVehicle === null || currentVehicle === void 0 ? void 0 : currentVehicle.name,
            Trim: {
                Id: 0,
                Key: currentVehicle === null || currentVehicle === void 0 ? void 0 : currentVehicle.trimKey,
                Name: currentVehicle === null || currentVehicle === void 0 ? void 0 : currentVehicle.trimName,
                GtmName: currentVehicle === null || currentVehicle === void 0 ? void 0 : currentVehicle.trimName,
            },
            Transmission: {
                Id: (currentVehicle === null || currentVehicle === void 0 ? void 0 : currentVehicle.transmissionDetIdentifier) || 0,
                Key: currentVehicle === null || currentVehicle === void 0 ? void 0 : currentVehicle.transmissionKey,
                Name: (currentVehicle === null || currentVehicle === void 0 ? void 0 : currentVehicle.transmissionName) || (currentVehicle === null || currentVehicle === void 0 ? void 0 : currentVehicle.defaultTransmission),
            },
            Colour: {
                Exterior: {
                    Id: 0,
                    Key: (currentVehicle === null || currentVehicle === void 0 ? void 0 : currentVehicle.exteriorColourKey) || currentVehicle.defaultExteriorColourKey,
                    Name: (currentVehicle === null || currentVehicle === void 0 ? void 0 : currentVehicle.exteriorColourName) || currentVehicle.defaultExteriorColourKey,
                    LargeSwatch: currentVehicle === null || currentVehicle === void 0 ? void 0 : currentVehicle.exteriorColourPreviewImageSrc,
                    UpCharge: 0,
                    FrequencyPayment: (exteriorColorPricing === null || exteriorColorPricing === void 0 ? void 0 : exteriorColorPricing.frequencyPayment) || 0,
                },
                Interior: {
                    Id: 0,
                    Key: (currentVehicle === null || currentVehicle === void 0 ? void 0 : currentVehicle.interiorColourKey) || currentVehicle.defaultInteriorColourKey,
                    Name: (currentVehicle === null || currentVehicle === void 0 ? void 0 : currentVehicle.interiorColourName) || currentVehicle.defaultInteriorColourKey,
                    LargeSwatch: currentVehicle === null || currentVehicle === void 0 ? void 0 : currentVehicle.interiorColourPreviewImageSrc,
                    UpCharge: 0,
                    FrequencyPayment: (interiorColorPricing === null || interiorColorPricing === void 0 ? void 0 : interiorColorPricing.frequencyPayment) || 0,
                },
            },
            Accessories: selectedAccessories,
            Warranty: !selectedWarranty
                ? null
                : {
                    Id: selectedWarranty === null || selectedWarranty === void 0 ? void 0 : selectedWarranty.id,
                    Key: selectedWarranty === null || selectedWarranty === void 0 ? void 0 : selectedWarranty.key,
                    Name: selectedWarranty === null || selectedWarranty === void 0 ? void 0 : selectedWarranty.name,
                    Value: (_d = selectedWarranty === null || selectedWarranty === void 0 ? void 0 : selectedWarranty.priceTotal) !== null && _d !== void 0 ? _d : 0,
                    FrequencyPayment: (_e = selectedWarranty === null || selectedWarranty === void 0 ? void 0 : selectedWarranty.frequencyPayment) !== null && _e !== void 0 ? _e : 0,
                    IsRecommended: isWarrantyRecommended !== null && isWarrantyRecommended !== void 0 ? isWarrantyRecommended : false,
                    Type: selectedWarrantyType !== null && selectedWarrantyType !== void 0 ? selectedWarrantyType : '',
                },
            OwnerPrograms: selectedProtections === null || selectedProtections === void 0 ? void 0 : selectedProtections.map(protection => { var _a; return ({ ...protection, Value: (_a = protection.Value) !== null && _a !== void 0 ? _a : 0 }); }),
        },
        Financials: {
            SelectedOffers: selectedOffers,
            FinancialCalculatorApiRequest: {
                ...paymentData === null || paymentData === void 0 ? void 0 : paymentData.payloadBody,
                paymentOptions: (_g = (_f = paymentData === null || paymentData === void 0 ? void 0 : paymentData.payloadBody) === null || _f === void 0 ? void 0 : _f.paymentOptions) === null || _g === void 0 ? void 0 : _g.map((option) => ({
                    ...option,
                    includeFees: isOnlineCreditApplication ? true : option.includeFees,
                    overriddenIsSellingProvince: isOnlineCreditApplication ? true : option.overriddenIsSellingProvince,
                })),
            },
            FinancialCalculatorApiResponse: paymentData === null || paymentData === void 0 ? void 0 : paymentData.originalResponse,
            FinancialCalculatorApiSummary: { Summaries: summary },
            FinancialSummaryApiResponse: summaryApiResponse,
        },
    };
    return transformedRequest;
};
export default transformSaveBuildRequest;
